import React from 'react';
import styled, { css } from 'styled-components';
import { TextBody } from '../../../Typography';
const TextBodyBox = styled.span `
  ${({ theme: { space } }) => css `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: ${space.xs};
  `}
`;
export const CardBody = ({ description, align }) => {
    if (description)
        return (React.createElement(TextBodyBox, { align: align },
            React.createElement(TextBody, { tag: "span", size: "sm" }, description)));
    return null;
};
//# sourceMappingURL=CardBody.js.map